<template>
  <div>
    <footer class="pt-4 pb-4" :class="pathname ? 'footer-margin' : ''">
      <div class="footer-content">
        <div class="row">
          <div class="col-12 d-md-none">
            <div id="mc_embed_signup " class="">
              <form
                action="https://gdc-tech.us3.list-manage.com/subscribe/post?u=17de026eae3d5830383759c75&amp;id=22a268fd8e"
                method="post"
                id="mc-embedded-subscribe-form"
                name="mc-embedded-subscribe-form"
                class="validate"
                target="_blank"
                novalidate
              >
                <div
                  id="mc_embed_signup_scroll"
                  class="input-group subscribe-box mb-1 "
                >
                  <input
                    type="email"
                    value=""
                    name="EMAIL"
                    class="email form-control susbscribe-input py-4"
                    id="mce-EMAIL"
                    placeholder="Enter your email"
                    style="border-top-left-radius:5px;border-bottom-left-radius:5px"
                    required
                  />
                  <!-- real people should not fill this in and expect good things - do not remove this or risk form bot signups-->
                  <div
                    style="position: absolute; left: -5000px;"
                    aria-hidden="true"
                  >
                    <input
                      type="text"
                      name="b_17de026eae3d5830383759c75_22a268fd8e"
                      tabindex="-1"
                      value=""
                    />
                  </div>
                  <div class="clear">
                    <input
                      type="submit"
                      value="Subscribe"
                      name="subscribe"
                      id="mc-embedded-subscribe"
                      class="button subscribe-new "
                    />
                  </div>
                </div>
              </form>
            </div>
            <div class="text-white">{{ message }}</div>
          </div>
          <div class="col-6 col-sm-6 col-md col-lg-3 col-xl-3">
            <ul class="p-0">
              <li>
                <router-link to="/hiw">How It Works</router-link>
              </li>
              <li>
                <router-link to="/offers-promotions"
                  >Offers &#38; Promotions</router-link
                >
              </li>
              <li>
                <router-link to="/aboutUs">About Us</router-link>
              </li>
              <li>
                <router-link to="/newsroom">Newsroom</router-link>
              </li>
              <!-- <li>
                <router-link to="/coming-soon">Career</router-link>
              </li> -->
            </ul>
          </div>
          <div class="col-6 col-sm-6 col-md col-lg-3 col-xl-3">
            <ul class="p-0">
              <li>
                <router-link to="/termsCondition"
                  >Terms &#38; Conditions</router-link
                >
              </li>
              <li>
                <router-link to="/privacyPolicy">Privacy Policy</router-link>
              </li>
              <li>
                <router-link to="/cookiesprivacyPolicy">Cookies</router-link>
              </li>
              <!-- href="https://api.whatsapp.com/send?phone=6588928400" -->
              <li class="d-md-none">
                <router-link style="cursor:pointer" to="/feedback"
                  >Contact Us</router-link
                >
              </li>
              <li class="d-md-none">
                <router-link to="/faqs">FAQ</router-link>
              </li>
            </ul>
          </div>
          <div
            class="col-6 col-sm-6 col-md-2 col-lg-2 col-xl-3 d-none d-md-block"
          >
            <ul class="p-0">
              <li>
                <!-- <router-link to="/coming-soon">Contact Us</router-link> -->
                <router-link to="/feedback" style="cursor:pointer"
                  >Contact Us</router-link
                >
              </li>
              <li>
                <router-link to="/faqs">FAQ</router-link>
              </li>
            </ul>
          </div>
          <div class="col-12 col-sm-12 col-md-5 col-lg-4 col-xl-3">
            <!-- <div class="d-none d-md-block">
              <div class="input-group subscribe-box mb-1">
                <div class="input-group-prepend">
                  <span
                    @click="subscribe()"
                    class="input-group-text btn susbscribe-icon"
                    id="basic-addon1"
                  >
                    <img
                      src="@/assets/img/svg/vector.svg"
                      height="18px"
                      width="18px"
                    />
                  </span>
                </div>
                <input
                  v-model="email"
                  type="text"
                  class="form-control susbscribe-input py-4"
                  placeholder="Subscribe to our newsletter"
                  aria-label="Username"
                  aria-describedby="basic-addon1"
                />
              </div>
            </div> -->
            <div id="mc_embed_signup " class="d-none d-md-block">
              <form
                action="https://gdc-tech.us3.list-manage.com/subscribe/post?u=17de026eae3d5830383759c75&amp;id=22a268fd8e"
                method="post"
                id="mc-embedded-subscribe-form"
                name="mc-embedded-subscribe-form"
                class="validate"
                target="_blank"
                novalidate
              >
                <div
                  id="mc_embed_signup_scroll"
                  class="input-group subscribe-box mb-1 "
                >
                  <input
                    type="email"
                    value=""
                    name="EMAIL"
                    class="email form-control susbscribe-input py-4"
                    id="mce-EMAIL"
                    placeholder="Enter your email"
                    style="border-top-left-radius:5px;border-bottom-left-radius:5px"
                    required
                  />
                  <!-- real people should not fill this in and expect good things - do not remove this or risk form bot signups-->
                  <div
                    style="position: absolute; left: -5000px;"
                    aria-hidden="true"
                  >
                    <input
                      type="text"
                      name="b_17de026eae3d5830383759c75_22a268fd8e"
                      tabindex="-1"
                      value=""
                    />
                  </div>
                  <div class="clear">
                    <input
                      type="submit"
                      value="Subscribe"
                      name="subscribe"
                      id="mc-embedded-subscribe"
                      class="button subscribe-new "
                    />
                  </div>
                </div>
              </form>
            </div>

            <div class="text-white d-none d-md-block">{{ message }}</div>

            <div class="py-3 py-md-0 border-mobile-top" v-if="false">
              <div class="text-white">Enjoy {{ TITLE }} on the go</div>
              <div class="d-flex">
                <div class="mr-2">
                  <!-- asdfadsfadsfadsf -->
                  <a
                    href="https://play.google.com/store/apps/details?id=com.gogo.cinema&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1"
                    target="_blank"
                  >
                    <img
                      alt="Get it on Google Play"
                      src="https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png"
                      class="img-fluid"
                      style="max-width:150px;margin-left: -10px;"
                    />
                  </a>
                </div>
                <div style="margin-top: 9px; ;">
                  <a
                    href="https://apps.apple.com/sg/app/gogocinema/id1477479261?mt=8"
                    target="_blank"
                  >
                    <img
                      src="https://linkmaker.itunes.apple.com/en-gb/badge-lrg.svg?releaseDate=2019-09-26&kind=iossoftware&bubble=ios_apps"
                      class="img-fluid"
                      style="max-width:135px"
                    />
                  </a>
                </div>

                <!-- <a href>
                  <img src="@/assets/img/svg/GooglePlay-icon.svg" height="auto" width="140" />
                </a>-->
              </div>
            </div>
          </div>

          <div class="col-12">
            <div class="border-top border-light"></div>
            <div class="d-flex justify-content-between align-items-center py-2">
              <!-- <ul class="social-icon">
                <li>
                  <a
                    target="_blank"
                    href="https://www.facebook.com/gogocinemasingapore/"
                  >
                    <img src="@/assets/img/svg/fb.svg" />
                  </a>
                </li>
                <li>
                  <a target="_blank" href="https://twitter.com/GoGoCinema1">
                    <img src="@/assets/img/svg/twitter.svg" />
                  </a>
                </li>
                <li>
                  <a
                    target="_blank"
                    href="https://www.instagram.com/gogocinema.singapore/"
                  >
                    <img src="@/assets/img/svg/insta.svg" />
                  </a>
                </li>
              </ul> -->
              <p class="text-white mb-0">&#9400; {{ dateYear }} {{ TITLE }}</p>
            </div>
          </div>

          <div class="popUp" v-if="pop" v-on:click="show()">
            <div class="content">
              Lorem ipsum dolor sit amet consectetur adipisicing elit.
              Doloremque ratione esse possimus assumenda, tempore nihil
              molestiae. Qui quos ratione expedita, amet voluptatum tenetur
              assumenda atque cumque sint laboriosam quibusdam error?
            </div>
          </div>
        </div>
      </div>
    </footer>

    <!-- ALL MODAL -->

    <!-- Modal Ends -->
  </div>
</template>

<script>
import { makeRequest } from "@/helper/internet.js";
import { TokenService } from "@/services/storage.service";
import EventBus from "@/eventBus.js";
import { PROJECT_TITLE } from "@/helper/constants";

export default {
  name: "footer-main",
  components: {},
  data() {
    return {
      pathname: false,
      pop: false,
      email: "",
      dateYear: "",
      message: "",
      slickOptions: {
        slidesToShow: 3
      },
      TITLE: PROJECT_TITLE
    };
  },
  mounted() {
    EventBus.$on("FOOTERSET", val => {
      this.pathname = val;
    });
    EventBus.$on("DateSet", val => {
      this.dateYear = val;
    });
    if (window.location.pathname.length == "1") {
      this.pathname = true;
    } else {
      this.pathname = false;
    }
  },
  methods: {
    //   footerset(val){
    //     this.pathname=val;
    // },
    show: function() {
      this.pop = !this.pop;
    },

    subscribe: function() {
      let bool = validateEmail(this.email);

      if (!bool) {
        this.message = "Please Enter Valid Email";
      } else {
        let token = TokenService.getToken();
        let payload = {
          Email: this.email
        };
        makeRequest("/Subscribe/", "POST", token, payload)
          .then(response => {
            const { error, res } = response;
            if (res.data.Status) {
              this.message = res.data.Message;
            } else {
              this.message = res.data.Message;
            }
          })
          .catch(error => {
            this.message = "You must be a user to subscribe";
          });
      }

      function validateEmail(email) {
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
      }
    }
  }
};
</script>
<style scoped>
footer {
  background: linear-gradient(172.42deg, #e70d00 17.86%, #fa5402 126.35%);
}

footer ul {
  list-style: none;
}

footer .form-control:focus {
  color: #8d99af;
  background-color: #fff;
  border-color: transparent;
  outline: 0;
  box-shadow: none;
  font-size: 12px;
}

footer .form-control {
  color: #8d99af;
  background-color: #fff;
  border-color: transparent;
  outline: 0;
  box-shadow: none;
  font-size: 12px;
}

.subscribe .susbscribe-input {
  border: none;
  color: #000;
  height: 50px;
  background-color: #fff;
  border-color: transparent;
  border-top-right-radius: 11px;
  border-bottom-right-radius: 11px;
}

.susbscribe-icon {
  background: #fff;
  line-height: 1;
}

.input-group-prepend span {
  border-top-left-radius: 11px;
  border-bottom-left-radius: 11px;
  border: none;
  padding-right: 2px;
}

.susbscribe-input {
  border-top-right-radius: 11px;
  border-bottom-right-radius: 11px;
  border: none;
}

.social-icon {
  list-style: none;
  padding: 0px;
  margin-bottom: 0;
}

.social-icon li {
  display: inline;
  padding-right: 5px;
}

footer li {
  line-height: 30px;
}

footer a {
  color: #fff;
  font-weight: bold;
}

footer a:hover {
  color: #fff;
}

.border-bt {
  position: relative;
}

.border-bt::after {
  position: absolute;
  content: "";
  border-top: 1px solid #fff;
  top: 20px;
  width: 50%;
  left: 0;
  right: 0;
  margin: 0 auto;
  opacity: 0.9;
}

.footer-content {
  width: 100%;
  margin: 0 auto;
  max-width: 1400px;
  padding-left: 15px;
  padding-right: 15px;
}

@media (max-width: 767px) {
  .border-mobile-top {
    border-top: 1px solid #fff;
    border-bottom: 1px solid #fff;
  }

  footer .border-top {
    border: none !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/partials/footer.vue